import { number } from 'card-validator';
import { type CardNumberVerification } from 'card-validator/dist/card-number';

const cardNumberValidator = (cardNumber: string): CardNumberVerification['isValid'] => {
  const { isValid } = number(cardNumber);
  return isValid;
};

export default cardNumberValidator;
